export default __webpack_public_path__ + "static/media/link.88eed3e2.svg";